import type { BlockType } from "../types"
import { getBlockContent } from "../types"
import { getDefaultBlockContent } from "../registry"
import { getBlockEditorComponent } from "./index"

interface BlockEditorSlotProps {
  block: { id: string; section_type: string; content: unknown }
  onChange: (content: Record<string, unknown>) => void
}

/**
 * Renders the appropriate block editor for a block.
 * Adapts block/content/onChange to each editor's expected props (content, onChange).
 */
export function BlockEditorSlot({ block, onChange }: BlockEditorSlotProps) {
  const type = block.section_type as BlockType
  const EditorComponent = getBlockEditorComponent(type)

  const content =
    getBlockContent(block, type) ?? getDefaultBlockContent(type)
  const handleChange = (newContent: Record<string, unknown>) =>
    onChange(newContent)

  return (
    <EditorComponent
      content={content as Record<string, unknown>}
      onChange={handleChange}
      block={block}
    />
  )
}
